import type { OrderListParams } from '../api/orders-api';

/** Store-scoped keys: switching stores never shares cache. */
export const orderKeys = {
  all: (storeId: string) => ['stores', storeId, 'orders'] as const,
  lists: (storeId: string) => [...orderKeys.all(storeId), 'list'] as const,
  list: (storeId: string, params: OrderListParams) =>
    [...orderKeys.lists(storeId), params] as const,
  details: (storeId: string) => [...orderKeys.all(storeId), 'detail'] as const,
  detail: (storeId: string, id: string) => [...orderKeys.details(storeId), id] as const,
  notifications: (storeId: string, id: string) =>
    [...orderKeys.detail(storeId, id), 'notifications'] as const,
};
